module.exports = __webpack_public_path__ + "img/ajgz.133ce968.png";